import Vue from 'vue';
import App from '@/App.vue';
import router from '@/router';
import store from '@/store';
import InforactUI from '@sonim1/inforact-ui';
import PerfectScrollbar from 'vue2-perfect-scrollbar';
import VCalendar from 'v-calendar';
import 'font-awesome/css/font-awesome.css';
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css';

// Importing the global css file
import '@/assets/global.scss';

Vue.config.productionTip = false;
store.dispatch('initialize');

Vue.use(InforactUI);
Vue.use(PerfectScrollbar, {
    options: {
        useBothWheelAxes: true,
    },
});
Vue.use(VCalendar, {
    componentPrefix: 'vc',
});

new Vue({
    router,
    store,
    render: h => h(App),
}).$mount('#app');
